import { BANK_NO, BANK_PAY_TYPE, CARD_TYPE } from '@/constant'
import { useI18n } from '@/hooks/useI18n'
export interface BankInfo {
  id: string
  payTypes: string[]
  getCardType: (cardNo: string) => string
  cardMsg: () => {
    name: string
    label: string
    placeholder: string
    maxLength: number
    reg: RegExp
    validErrText: string
  }
}

export interface Card {
  name: string
  label: string
  placeholder: string
  maxLength: number
  reg: RegExp
  validErrText: string
}

/**
 * 中银VM
 * 大西洋
 * 银联
 */
export const BANK_MAP: Map<string, BankInfo> = new Map([
  [
    BANK_NO.BOC_VM,
    {
      id: BANK_NO.BOC_VM,
      payTypes: [BANK_PAY_TYPE.BOC_VM],
      // 卡类型为信用卡
      getCardType: () => CARD_TYPE.CREDIT,
      cardMsg: (): Card => {
        const { t } = useI18n()
        return {
          name: t('routes.validCardInfo.bocVM.name'),
          label: t('routes.validCardInfo.bocVM.label'),
          placeholder: t('routes.validCardInfo.bocVM.placeholder'),
          maxLength: 16,
          reg: /^(4|5)\d{15}$/,
          validErrText: t('routes.validCardInfo.bocVM.validErrText'),
        }
      },
    },
  ],
  [
    BANK_NO.BNU,
    {
      id: BANK_NO.BNU,
      payTypes: [BANK_PAY_TYPE.BNU],
      // 大西洋15或16位是信用卡 其他是账户
      getCardType: (cardNo) =>
        cardNo.length === 15 || cardNo.length === 16 ? CARD_TYPE.CREDIT : CARD_TYPE.ACCOUNT,
      cardMsg: (): Card => {
        const { t } = useI18n()
        return {
          name: t('routes.validCardInfo.bnu.name'),
          label: t('routes.validCardInfo.bnu.label'),
          placeholder: t('routes.validCardInfo.bnu.placeholder'),
          maxLength: 16,
          reg: /(^\d{10}$)|(^\d{15}$)|(^\d{16}$)/,
          validErrText: t('routes.validCardInfo.bnu.validErrText'),
        }
      },
    },
  ],
  [
    BANK_NO.UNION_PAY,
    {
      id: BANK_NO.UNION_PAY,
      payTypes: [BANK_PAY_TYPE.UNION_PAY],
      // 卡类型为信用卡
      getCardType: () => CARD_TYPE.CREDIT,
      cardMsg: (): Card => ({
        name: '銀聯信用卡',
        label: '銀聯信用卡',
        placeholder: '請輸入銀行卡號',
        maxLength: 16,
        reg: /^(1|2|3|4|5)\d{15}$/,
        validErrText: '請輸入正確的銀行卡號',
      }),
    },
  ],
])
